// ── mentionText ───────────────────────────────────────────────────────────────
// The pure string half of @mention editing: what the caret is sitting in, and what
// the textarea should contain afterwards. No React, no supabase — so the behaviour
// that actually breaks (caret maths) is unit-testable rather than only reachable by
// clicking through a horizontally-scrolling tab strip.
//
// Lifted out of ReviewComposer when the episode-comment composer needed the same
// behaviour; useMentions is now thin glue over these.

// An in-progress "@handle" immediately left of the caret, or null.
// Anchored to a word boundary on purpose: an email address (foo@bar) must NOT open
// the autocomplete mid-word.
export function detectMention(value, caret) {
  const upto = String(value ?? '').slice(0, caret)
  const m = /(?:^|\s)@([A-Za-z0-9_]{0,30})$/.exec(upto)
  if (!m) return null
  return { query: m[1].toLowerCase(), start: caret - m[1].length - 1 }
}

// Replace the half-typed handle with the chosen one. Returns the next value and
// where the caret belongs, which the caller restores after paint — otherwise the
// browser drops it at the end of the textarea and typing continues in the wrong place.
export function applyMention(value, caret, mention, username) {
  const v = String(value ?? '')
  const at = mention?.start ?? caret
  const inserted = `@${username} `
  const next = v.slice(0, at) + inserted + v.slice(caret)
  return { next, pos: at + inserted.length }
}

// The @ button: drop an @ at the caret, space-prefixed so it starts a word (and so
// detectMention will actually match it).
export function applyAtInsert(value, caret) {
  const v = String(value ?? '')
  const needSpace = caret > 0 && !/\s/.test(v[caret - 1])
  const ins = (needSpace ? ' ' : '') + '@'
  return { next: v.slice(0, caret) + ins + v.slice(caret), pos: caret + ins.length }
}
